import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueWechatTitle from 'vue-wechat-title'; //统一标题
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './styles/tools.scss'
Vue.use(VueWechatTitle);
Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.$uploadPath = process.env.VUE_APP_UPLOAD_URL || '/'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
